import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.494 11.84a.833.833 0 0 0 1.179 0L10 9.511l2.327 2.327a.833.833 0 0 0 1.179-1.178l-2.917-2.917a.833.833 0 0 0-1.178 0L6.494 10.66a.833.833 0 0 0 0 1.178",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }